import Loader from "react-loader-spinner";
import { faHeadset, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment, useEffect, useRef, useState } from "react";
import { Alert, Button, Form, FormGroup, Modal, Row, Table } from "react-bootstrap";
import { getHappyCallResult, getHappyCallStatusList, getHappycallQuestionList, saveHappycallResult, changeHappyCallStatus } from "../../CRM/store/api/HappycallAPI";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { CheckLg, CheckSquare, ExclamationTriangle } from "react-bootstrap-icons";
import NewNumberInput from "../../Components/NewNumberInput";
const ModalHappyCall = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const hcStatus = useRef(null);
    const [error, setError] = useState(null);
    const { popData, setPopData } = props;
    const [happyCallResult, setHappyCallResult] = useState(null);
    const [hcStatusList, setHCStatusList] = useState([]);
    const { show } = popData;
    const { handleSubmit, register, errors } = useForm();

    const [questionList, setQuestionList] = useState([]);
    function close() {
        setPopData({
            show: false
        })
        setError(null);
        setHappyCallResult(null);
    }
    function onSubmit(data) {
        setError(null);
        let results = [];
        const cost = data.HappyCallCost;
        delete data.HappyCallCost;
        const desc = data.HappyCallDesc;
        delete data.HappyCallDesc;
        const st = data.HappyCallStatus;
        delete data.HappyCallStatus;
        Object.keys(data).forEach(key => results.push({ ID: key, Value: data[key] }));
        let dataToSend = {
            ProductId: popData.ProductID,
            ServiceType: popData.ServiceType,
            ServiceID: popData.ServiceID,
            FromWeb: true,
            HappyCallCost: cost,
            HappyCallDesc: desc,
            HappyCallStatus: st,
            Results: results
        }
        const onResBack = (res) => {
            if (res.Error) {
                setError(res.Error);
            }
            else {
                close();
            }
        }
        saveHappycallResult(dataToSend, onResBack);
    }
    function findAnswer(questionID) {
        if (happyCallResult?.Data && Array.isArray(happyCallResult.Data.ResultList)) {
            const answerID = happyCallResult.Data.ResultList.find(a => Number(a.QuestionID) === Number(questionID))?.AnswerID;
            return answerID ?? "";
        }
        return "";
    }
    function changeStatus() {
        changeHappyCallStatus(popData.ServiceType, popData.ServiceID, hcStatus.current, close);
    }
    useEffect(() => {
        const activeInInstall = popData?.ServiceType?.toLowerCase() === "install";
        const activeInRepair = popData?.ServiceType?.toLowerCase() === "repair";
        if (show) {
            if (questionList.length === 0) {
                getHappycallQuestionList(0, activeInInstall, activeInRepair, setQuestionList);
            }
            if (hcStatusList.length === 0) {
                getHappyCallStatusList(setHCStatusList);
            }
        }
        if (show) {
            const onGet = (res) => {
                if (res.Error) {
                    setError(res.Error);
                }
                else {
                    setHappyCallResult(res);
                }
            }
            getHappyCallResult(popData.ServiceType, popData.ServiceID, onGet);
        }
    }, [show])
    return (
        <Modal show={show} onHide={() => { }} size="lg">
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faHeadset} size="lg" />&nbsp;
                    رضایت سنجی سرویس {popData.PServiceType} شماره {popData.InvoiceNumber}
                </span>
                <FontAwesomeIcon icon={faTimes} onClick={close} size="lg" />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <table style={{ width: "100%" }}>
                    <tbody style={{ background: "linear-gradient(-45deg, #c7d1e7, transparent)" }}>
                        <tr>
                            <td style={{ fontWeight: "bold", padding: "4px", borderTopRightRadius: "3px", width: "115px" }}> مشخصات محصول : </td>
                            <td style={{ padding: "4px", borderTopLeftRadius: "3px" }} >{popData.ProductName + '-' + popData.ProductModel}</td>
                            <td style={{ fontWeight: "bold", padding: "4px", borderTopRightRadius: "3px", width: "115px" }}>نام مشتری: </td>
                            <td style={{ padding: "4px", borderTopLeftRadius: "3px" }}>{popData.CustomerName}</td>
                        </tr>
                        <tr>
                            <td style={{ fontWeight: "bold", padding: "4px" }}> سریال محصول: </td>
                            <td style={{ padding: "4px" }}>{popData.ProductSerial}</td>
                            <td style={{ fontWeight: "bold", padding: "4px", width: "155px" }}>شماره تماس مشتری: </td>
                            <td style={{ padding: "4px" }}>{(popData.CustomerMobile ?? "") + "," + (popData.CustomerPhone ?? "")}</td>
                        </tr>
                        <tr>
                            <td style={{ fontWeight: "bold", padding: "4px", borderBottomRightRadius: "3px", width: "115px" }}>تاریخ تماس: </td>
                            <td style={{ padding: "4px" }}>{popData.ContactDate}</td>
                            <td style={{ fontWeight: "bold", padding: "4px", borderBottomLeftRadius: "3px", width: "115px" }}>
                                {popData.SendDeliveryDate ? "تاریخ تحویل/ارسال:" : ""}
                            </td>
                            <td style={{ padding: "4px", borderBottomLeftRadius: "3px" }}>
                                {popData.SendDeliveryDate ? popData.SendDeliveryDate : ""}
                            </td>


                        </tr>
                    </tbody>
                </table>
                {
                    !happyCallResult?.Data &&
                    <div className="mt-1" style={{ textAlign: "center" }}>
                        <Loader type="BallTriangle" color="#bb1370" width={25} height={25} style={{ display: "inline-block" }} />
                    </div>
                }
                {
                    happyCallResult?.Data &&
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Table responsive className="fixedTable mt-1">
                            <thead>
                                <tr>
                                    <th style={{ width: "85%" }}>سوال</th>
                                    <th style={{ width: "15%" }}>پاسخ</th>
                                </tr>
                            </thead>
                            <tbody>
                                {questionList && Array.isArray(questionList) && questionList.map((item, i) =>
                                    <tr key={i} className="resultTableRow">
                                        <td style={{ width: "85%", padding: "14px" }}>{item.QuestionText}</td>
                                        <td style={{ width: "15%" }}>
                                            <div style={{height:"100%"}}>
                                                <select name={item.ID} className="tableRowInput" ref={register({ required: true })} style={{ borderColor: errors && errors[item.ID] ? "red" : "#8b919e" }} defaultValue={findAnswer(item.ID)}>
                                                    <option value="">انتخاب کنید</option>
                                                    {item?.AnswerList && Array.isArray(item.AnswerList) && item.AnswerList.map((answer, i) => {
                                                        return (
                                                            <option key={i} value={answer.ID}> {answer.AnswerText}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                        </td>
                                    </tr>)}
                            </tbody>
                        </Table>
                        <Row>
                            <FormGroup className="col-md-6">
                                <label style={{ color: "blue" }}>مبلغ دریافتی از مشتری:</label>
                                <NewNumberInput inputname="HappyCallCost" reff={register()} defaultValue={happyCallResult?.Data?.HappyCallCost ?? 0} />
                            </FormGroup>
                            <FormGroup className="col-md-6">
                                <label style={{ color: "blue" }}>وضعیت رضایت سنجی: </label>
                                {
                                    hcStatusList === "PENDING" &&
                                    <div className="form-control">
                                        <Loader type="BallTriangle" color="#bb1370" width={20} height={20} style={{ display: "inline-block" }} /> &nbsp;
                                        در حال بارگذاری لیست
                                    </div>
                                }
                                {
                                    hcStatusList?.Data && Array.isArray(hcStatusList.Data) &&
                                    <Fragment>
                                        <select className="form-control" name="HappyCallStatus" ref={register({})} defaultValue={happyCallResult?.Data?.HappyCallStatus ?? ""}
                                            onChange={e => hcStatus.current = e.target.value}>
                                            <option value="">انتخاب کنید</option>
                                            {hcStatusList.Data.map((st, i) => <option value={st.ID} key={i}>{st.InfoName}</option>)}
                                        </select>
                                        <Button className="btn-input-tiny" title="ثبت وضعیت" onClick={changeStatus}><CheckSquare size={18} /></Button>
                                    </Fragment>
                                }

                            </FormGroup>
                            <FormGroup className="mt-1">
                                <label style={{ color: "blue" }}>توضیحات:</label>
                                <Form.Control name="HappyCallDesc" ref={register()} defaultValue={happyCallResult?.Data?.HappyCallDesc ?? ""} />
                            </FormGroup>
                        </Row>
                        <Button className="group-Btn mt-1" variant="success" type="submit"><CheckLg size={15} />&nbsp;ثبت پرسشنامه </Button>
                    </form>
                }
                {error && <Alert variant="danger" className="mt-1">
                    <ExclamationTriangle size={18} />&nbsp;
                    {error}
                </Alert>}
            </Modal.Body>
        </Modal>
    )

}
export default ModalHappyCall;